require('./toolbar.style');
const template = require('./toolbar.template');
import { 
	IMenuItem,
	NestedMenuItem, 
	SortTuple,
	SortType ,
	ViewType
} from 'sharebase/domain';
import { 
	Action, 
	IDictionary ,
	IStorageAccessor
} from 'util/domain';
import { PhoenixToggleService } from 'phoenix/services/phoenixToggleService';
import { CommonUtilsService } from 'util/services';

class ToolbarController implements ng.IComponentController {
	public items:IDictionary<IMenuItem|NestedMenuItem>;
	public showAll:boolean = angular.isDefined(this.showAll) ? !!this.showAll : true;
	public animatingItems:boolean = false;
	public target:any;
	public sortType:SortTuple = angular.isDefined(this.sortType) ? this.sortType : {
		type: 'Name',
		ascending: false
	};
	public viewType:ViewType;
	public views:ViewType[];
	public readonly tooltipDelay = angular.isNumber(this.tooltipDelay) && this.tooltipDelay > 0 
		? this.tooltipDelay :
		100;

	private onSort:(args:object)=>void;
	private onToggleDetails:Action;
	private onToggleViewType:Action;
	private smartView:Boolean;
	public smartViewToolTipDismissed:boolean = undefined;

	public static $inject = [
		'$timeout',
		'utils',
		'pxPhoenixToggleService',
		'sessionStorageService'
	];

	constructor(
		private $timeout:ng.ITimeoutService,
		public utils:CommonUtilsService,
		private featureService: PhoenixToggleService,
		private sessionStorageService:IStorageAccessor
	){				
	}

	public sort(type:SortType, event?:ng.IAngularEvent){
		if(angular.isFunction(this.onSort)){
			this.onSort({
				sort:type,
				ev:event
			});
		}
	}

	public toggleDetails(){
		if(angular.isFunction(this.onToggleDetails)){
			this.onToggleDetails();
		}
	}

	public closeViewToolTip(){
		this.smartViewToolTipDismissed = true;
		
		//save the dismissed value for the session
		this.sessionStorageService.setStoredValue('viewDismissed-'+ this.getViewToolTipStorageObj(this.target).type + '-' + this.getViewToolTipStorageObj(this.target).id, 'true');
	}

	public toggleViewType(){
		if(angular.isFunction(this.onToggleViewType)){
			this.onToggleViewType();
		}
	}
	
	public get smartViewEnabled(){
		return this.featureService.isEnabled('Core/Smart-Views');
	}

	public get showSmartViewToolTip(){
		let val = this.smartView && this.views.length > 1 && !this.smartViewToolTipDismissed;
		if(val){this.activeToolTip=true;}
		return val;
	}
	
	public get activeToolTip(){
		return this.showSmartViewToolTip;
	}
	public set activeToolTip(val:boolean){
		if(!val){
			this.smartViewToolTipDismissed = true;
		}		
	}

	public get viewIcon(){
		let activeView:ViewType[] = this.views.filter(v=>{return v.name === this.viewType.name});
		if(activeView.length===1){
			return activeView[0].icon;
		}

		return '';
	}
	public $onChanges(changes:ng.IOnChangesObject) {
		if(changes.target){
			if(!changes.target.currentValue){ return; }

			this.animateItems();

			let dismissed = this.sessionStorageService.getStoredValue('viewDismissed-'+ this.getViewToolTipStorageObj(changes.target.currentValue).type + '-' + this.getViewToolTipStorageObj(changes.target.currentValue).id) !=='' ? true :undefined;
			this.smartViewToolTipDismissed = dismissed;
		}
	}

	public get visibleItemsCount(){
		return Object.keys(this.items).filter(i => this.items[i].visible).length;
	}

	private animateItems = (() => {
		let timer:ng.IPromise<boolean>;

		return () => {
			this.animatingItems = true;
			if(timer){
				this.$timeout.cancel(timer);
			}
			timer = this.$timeout(() => this.animatingItems = false, 1000);
		};
	})();

	private getViewToolTipStorageObj(target){
		return angular.isDefined(target.FolderId) ? {type:'folder', id: target.FolderId} : {type:'document', id: target.DocumentId};
		
	}
}

export const ToolbarComponent:ng.IComponentOptions = {
	template,
	controller: ToolbarController,
	controllerAs: 'vm',
	bindings: {
		items: '<',
		target: '<?',
		viewType: '=',
		smartView: '=',
		views:'<?',
		sortType: '<?',
		showAll:'<?',
		onSort: '&?',
		onToggleDetails:'&?',
		onToggleViewType:'&?',
		tooltipDelay: '<?'
	}
};


// WEBPACK FOOTER //
// ./src/sharebase/components/toolbar/toolbar.ts